module.exports = __webpack_public_path__ + "staticPO/img/QRCodeForNIBMPayment.8831f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QRCodeForNIBMPayment.png
// module id = 047g
// module chunks = 1